import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import styles from './index.scss';

type EventLike = {
  target: {
    value: string
  }
}
type props = {
  isMonthly?: boolean,
  isSwitchToAnnual?: boolean,
  onChange: (evt: EventLike) => void,
}

const IAgreeCheckbox: React.FunctionComponent<props> = ({
  isMonthly,
  onChange,
  isSwitchToAnnual,
}) => {
  const agreeLabelMessage = React.useMemo(() => {
    if (isSwitchToAnnual) {
      return (
        <FormattedMessage
          id=""
          description="'I agree' legal text for a payment form."
          defaultMessage={
              'I agree to the HelloSign <l1>Terms</l1>, <l2>Privacy Policy</l2>, <l3>Refund Policy</l3>,'
              + ' and <b>Automatic Renewal Terms</b> above.'
            }
          values={{
          /* eslint-disable react/display-name */
            b: (...chunks: any[]) => <b>{chunks}</b>,
            l1: (...chunks: any[]) => <a href="https://www.hellosign.com/terms" target="__blank">{chunks}</a>,
            l2: (...chunks: any[]) => <a href="https://www.hellosign.com/privacy" target="__blank">{chunks}</a>,
            l3: (...chunks: any[]) => <a href="https://www.hellosign.com/legal/tos#cancel_account" target="__blank">{chunks}</a>,
          /* eslint-enable react/display-name */
          }} />
      );
    } else if (isMonthly) {
      return (
        <FormattedMessage
          id=""
          description="Label for a checkbox authorizing HelloSign to charge the user's credit card."
          defaultMessage="I agree to allow HelloSign to charge my credit card annually." />
      );
    } else {
      return (
        <FormattedMessage
          id=""
          description="Label for a checkbox authorizing HelloSign to charge the user's credit card."
          defaultMessage="I agree to allow HelloSign to charge my credit card monthly." />
      );
    }

  }, [isSwitchToAnnual, isMonthly]);

  return (
    <div className={classNames(styles.switchBillingPeriodModalAgreeContainer, {
      [styles.marginTop]: !isSwitchToAnnual,
    })}
    >
      <input
        id="switchBillingPeriodModalAgreeCheckbox"
        type='checkbox'
        onChange={onChange} />
      <label
        className={styles.switchBillingPeriodModalAgreeLabel}
        htmlFor="switchBillingPeriodModalAgreeCheckbox"
      >
        {agreeLabelMessage}
      </label>
    </div>
  );
};

export default IAgreeCheckbox;
